import { CompanyListConstants } from './types';

export const COMPANY_LIST_CONSTANTS: CompanyListConstants = {
  MAX_COMPANIES_DISPLAY: 6,
  GRID_BREAKPOINTS: {
    xs: 1,
    sm: 2,
    md: 3,
    lg: 3,
  },
  SPACING: {
    section: 4,
    grid: 3,
  },
};

export const COMPANY_LIST_TEXT = {
  TITLE: '內推公司',
  NO_COMPANIES_MESSAGE: '目前尚無可顯示的內推公司。',
  VIEW_MORE_BUTTON: '更多公司',
  CHEVRON_ALT: '右側箭頭',
} as const;

export const COMPANY_LIST_URLS = {
  CHEVRON_ICON: 'https://cdn.prod.website-files.com/63fd958eb41ee76ac86a4ef6/641c028c177dbc7346799a86_Chevron.svg',
  COMPANIES_PAGE: '/companies',
  DEFAULT_COMPANY_LOGO: '/defaultCompanyLogo.png',
} as const;
